import React from "react";
export const getInvestmentStatusTag = (investmentStatus) => {
	if (investmentStatus === "INITIATED") {
		return <div className='bg-orange-50 w-fit rounded-lg text-orange-700 py-1 px-2 text-xs font-semibold'>Pending</div>
	}
	if (investmentStatus === "SUCCESSFUL") {
		return <div className='bg-green-200 w-fit rounded-lg text-green-700 py-1 px-2 text-xs font-semibold'>Success</div>
	}
}